import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const sid = new URLSearchParams(window.location.search).get("session_id");
  useEffect(() => { setTimeout(() => nav(`/account?session_id=${sid}`), 1200); }, [nav, sid]);
  return (
    <div className="py-24 text-center">
      <CheckCircle2 className="w-16 h-16 text-cyan-400 mx-auto mb-4" />
      <h1 className="font-display text-3xl font-extrabold">Payment received</h1>
      <p className="text-zinc-400 mt-2">Activating your Premium…</p>
    </div>
  );
}
